import { useEffect } from 'react';

import AOS from 'aos';

// routes
import Routes from './routes/Routes';

// Themes
import './assets/scss/theme.scss';
import 'moment/locale/id';

// Skeleton
import 'react-loading-skeleton/dist/skeleton.css';

// React date picker
import 'react-datepicker/dist/react-datepicker.css';

const App = () => {
    console.log('%c HOLDING version ', 'background: #203354; color: #fff', process.env.REACT_APP_HOLDING_VERSION);

    useEffect(() => {
        AOS.init();
    }, []);
    return <Routes />;
};

export default App;
